import React from 'react'
import Link from 'gatsby-link'
import { Box, Typography, useTheme } from '@mui/material'

import { rudderslabTrackOnClick } from '../utils/common'

import { PortableText } from './PortableText'

import Image from '@components/Image'

export type CardProps = {
  title: string
  smalltitle?: string
  applyGradientColorTheme: boolean
  four_card_items: {
    card_image: {
      asset: {
        _ref: string
        url: string
        altText: string
      }
    }
    addlink: {
      cmn_display_as_button: boolean
      cmnexternallink: boolean
      cmnlinktext: string
      cmnlink: string
      _key: string
    }
    _key: string
    content: object
    title: string
  }[]
}
export const FourCardsWithTitleLeftAligned = ({ ...props }: CardProps) => {
  const { palette } = useTheme()
  return (
    <Box
      component='section'
      sx={{
        px: { xs: 2, tablet: 0 },
        pt: 10,
        position: 'relative',
      }}>
      <Box
        sx={{
          m: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          flexDirection: { xs: 'row', tablet: 'column' },
          textAlign: 'center',
          mb: 12,
          maxWidth: 896,
        }}>
        {props.title !== '' && (
          <Typography
            variant='h2'
            sx={{
              mb: 2,
              fontSize: { xs: 40, tablet: 50 },
            }}>
            {props.title}
          </Typography>
        )}
        {props.smalltitle !== '' && (
          <Typography
            variant='body2'
            sx={{
              width: '100%',
              fontSize: { tablet: 18 }
            }}>
            {props.smalltitle}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          maxWidth: 1024,
          px: { tablet: 1.5 },
          mx: 'auto',
        }}>
        {/* Data WorkFlow */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: { xs: 'column', laptop: 'row' },
            justifyContent: 'space-between',
            gap: { xs: 5, desktop: 10 },
          }}>
          {props.four_card_items.map((item, k) => (
            <Box
              key={item._key}
              sx={{
                textAlign: 'center',
                width: {
                  xs: '100%',
                  laptop: 'width: calc(50% - 50px)',
                  desktop: 'calc(50% - 68px)',
                },
                mb: 8,
              }}>
              <Box>
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <Box component={Image} alt={item.card_image?.asset?.altText} url={item.card_image?.asset?.url} />
                </Box>

                <Typography
                  variant='h2'
                  sx={{
                    mb: 1,
                    color: palette.secondary.main,
                    fontSize: 28,
                  }}>
                  {item.title}
                </Typography>

                <Box
                  sx={{
                    lineHeight: 1.625,
                    fontSize: { xs: 14, mobile: 18 },
                    color: palette.background.default,
                  }}>
                  <PortableText
                    blocks={item.content}
                    trackSectionHeader={item.title}
                  />
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mt: 4,
                  }}>
                  <Box
                    component={item?.addlink?.cmnexternallink ? 'a' : Link}
                    href={item?.addlink?.cmnlink}
                    to={item?.addlink?.cmnlink}
                    onClick={e =>
                      rudderslabTrackOnClick(
                        item?.addlink?.cmn_display_as_button
                          ? 'button'
                          : 'link',
                        item.title,
                        e
                      )
                    }
                    sx={{
                      width: 'fit-content',
                      alignItems: 'center',
                      borderRadius: 2,
                      display: 'flex',
                      mt: 4,
                      ...(props.applyGradientColorTheme && {
                        color: palette.text.primary,
                        '&:hover': {
                          color: palette.info.main,
                        },
                        '&:before': {
                          content: `''`,
                          background:
                            'url("/images/arrow-right-action.svg") no- repeat',
                          backgroundPosition: 'center',
                          width: 20,
                          height: '100%',
                          top: 0,
                          left: '50%',
                          p: 1.25,
                          mr: 1.25,
                        },
                      }),
                    }}>
                    {item?.addlink?.cmnlinktext}
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
